export { FACET_SEARCH_ROUTE_QUERY_PARAM, SHIPPING_DATE_FILTER_QUERY_PARAM } from "../product-list-controls/product-list-controls.constants";
export { MOV_FILTER_QUERY_PARAM } from "../mov-filter/mov-filter.constants";
export { SUPPLY_TYPE_FILTER_QUERY_PARAM } from "../supply-type-filter/supply-type-filter.constants";

export const PRODUCTS_COLLECTION_SLUG = "products" as const;
export const TRENDING_OFFERS_COLLECTION_SLUG = "trending-offers" as const;
export const CONSOLIDATED_FEED_MOV_TIERS_CENTS = [
    1_000_000,
    2_000_000,
    3_000_000,
    5_000_000,
] as const;

export const CONSOLIDATED_FEED_DEFAULT_CHECKOUT_MOV_CENTS =
    CONSOLIDATED_FEED_MOV_TIERS_CENTS[0];

export const CONSOLIDATED_FEED_CHECKOUT_MOV_CENTS =
    CONSOLIDATED_FEED_DEFAULT_CHECKOUT_MOV_CENTS;

export const CONSOLIDATED_FEED_DEFAULT_PREVIEW_MOV_CENTS =
    CONSOLIDATED_FEED_MOV_TIERS_CENTS[1];

export const CONSOLIDATED_FEED_MOV_CENTS = CONSOLIDATED_FEED_CHECKOUT_MOV_CENTS;
export const CONSOLIDATED_FEED_ETA = "2–4 weeks";

export const SUPPLY_TYPE_FILTER_COLLECTION_SLUGS = [
    PRODUCTS_COLLECTION_SLUG,
    TRENDING_OFFERS_COLLECTION_SLUG,
] as const;

export function supportsSupplyTypeFilter(
    slug: string | null,
    supplierId: string | null,
): boolean {
    return (
        !supplierId &&
        slug != null &&
        (SUPPLY_TYPE_FILTER_COLLECTION_SLUGS as readonly string[]).includes(slug)
    );
}

export const PRODUCT_LIST_SIDEBAR_STORAGE_KEY = "venduro_product_sidebar_open" as const;
export const PAGE_QUERY_PARAM = "page" as const;
export const PER_PAGE_QUERY_PARAM = "perPage" as const;
export const SORT_QUERY_PARAM = "sort" as const;
export const ORDER_QUERY_PARAM = "order" as const;
export const LEGACY_SEARCH_QUERY_PARAM = "search" as const;
